import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { SidenavItemTooltip } from './Sidenav.Item.Tooltip.es.js';

const SidenavItem = /*#__PURE__*/ forwardRef(({ name, active = false, children, className, ...props }, ref)=>{
    return jsx(SidenavItemTooltip, {
        content: children,
        children: jsx("a", {
            ref: ref,
            className: classNames('cb-sidenav-item', className, {
                active
            }),
            ...props,
            children: jsxs("span", {
                className: "inner",
                children: [
                    active ? jsx(Icon.Gradient, {
                        className: "item-icon",
                        name: name,
                        size: 20,
                        variant: "BluePurple"
                    }) : jsx(Icon, {
                        className: "item-icon",
                        name: name,
                        size: 20
                    }),
                    jsx("span", {
                        className: "label",
                        children: children
                    })
                ]
            })
        })
    });
});
SidenavItem.displayName = 'Sidenav.Item';

export { SidenavItem };
//# sourceMappingURL=Sidenav.Item.es.js.map
